import { render, staticRenderFns } from "./vipDetail.vue?vue&type=template&id=8c9db198&scoped=true"
import script from "./vipDetail.vue?vue&type=script&lang=js"
export * from "./vipDetail.vue?vue&type=script&lang=js"
import style0 from "./vipDetail.vue?vue&type=style&index=0&id=8c9db198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9db198",
  null
  
)

export default component.exports